var $8Zqhq$reactarialiveannouncer = require("@react-aria/live-announcer");
var $8Zqhq$reactariaoverlays = require("@react-aria/overlays");
var $8Zqhq$reactarialistbox = require("@react-aria/listbox");
var $8Zqhq$reactariautils = require("@react-aria/utils");
var $8Zqhq$react = require("react");
var $8Zqhq$reactstatelycollections = require("@react-stately/collections");
var $8Zqhq$reactariaselection = require("@react-aria/selection");
var $8Zqhq$reactariai18n = require("@react-aria/i18n");
var $8Zqhq$reactariamenu = require("@react-aria/menu");
var $8Zqhq$reactariatextfield = require("@react-aria/textfield");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "useComboBox", () => $242452271d1e4c0e$export$8c18d1b4f7232bbf);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */

var $8d1e5da058b86bb9$exports = {};
var $a756282ae45b5180$exports = {};
$a756282ae45b5180$exports = {
  "buttonLabel": "\u0639\u0631\u0636 \u0627\u0644\u0645\u0642\u062A\u0631\u062D\u0627\u062A",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " \u062E\u064A\u0627\u0631"),
    other: () => "".concat(formatter.number(args.optionCount), " \u062E\u064A\u0627\u0631\u0627\u062A")
  }), " \u0645\u062A\u0627\u062D\u0629."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "\u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0645\u062F\u062E\u0644\u0629 ".concat(args.groupTitle, ", \u0645\u0639 ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " \u062E\u064A\u0627\u0631"),
      other: () => "".concat(formatter.number(args.groupCount), " \u062E\u064A\u0627\u0631\u0627\u062A")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", \u0645\u062D\u062F\u062F",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "\u0645\u0642\u062A\u0631\u062D\u0627\u062A",
  "selectedAnnouncement": args => "".concat(args.optionText, "\u060C \u0645\u062D\u062F\u062F")
};
var $50569559b1387c57$exports = {};
$50569559b1387c57$exports = {
  "buttonLabel": "\u041F\u043E\u043A\u0430\u0436\u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " \u043E\u043F\u0446\u0438\u044F"),
    other: () => "".concat(formatter.number(args.optionCount), " \u043E\u043F\u0446\u0438\u0438")
  }), " \u043D\u0430 \u0440\u0430\u0437\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "\u0412\u044A\u0432\u0435\u0434\u0435\u043D\u0430 \u0433\u0440\u0443\u043F\u0430 ".concat(args.groupTitle, ", \u0441 ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " \u043E\u043F\u0446\u0438\u044F"),
      other: () => "".concat(formatter.number(args.groupCount), " \u043E\u043F\u0446\u0438\u0438")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", \u0438\u0437\u0431\u0440\u0430\u043D\u0438",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "selectedAnnouncement": args => "".concat(args.optionText, ", \u0438\u0437\u0431\u0440\u0430\u043D\u0438")
};
var $bff243ee21f5616f$exports = {};
$bff243ee21f5616f$exports = {
  "buttonLabel": "Zobrazit doporu\u010Den\xED",
  "countAnnouncement": (args, formatter) => "K dispozici ".concat(formatter.plural(args.optionCount, {
    one: () => "je ".concat(formatter.number(args.optionCount), " mo\u017Enost"),
    other: () => "jsou/je ".concat(formatter.number(args.optionCount), " mo\u017Enosti/-\xED")
  }), "."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Zadan\xE1 skupina \u201E".concat(args.groupTitle, "\u201C ").concat(formatter.plural(args.groupCount, {
      one: () => "s ".concat(formatter.number(args.groupCount), " mo\u017Enost\xED"),
      other: () => "se ".concat(formatter.number(args.groupCount), " mo\u017Enostmi")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: " (vybr\xE1no)",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "N\xE1vrhy",
  "selectedAnnouncement": args => "".concat(args.optionText, ", vybr\xE1no")
};
var $1508d10b8eb2180a$exports = {};
$1508d10b8eb2180a$exports = {
  "buttonLabel": "Vis forslag",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " mulighed tilg\xE6ngelig"),
    other: () => "".concat(formatter.number(args.optionCount), " muligheder tilg\xE6ngelige")
  }), "."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Angivet gruppe ".concat(args.groupTitle, ", med ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " mulighed"),
      other: () => "".concat(formatter.number(args.groupCount), " muligheder")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", valgt",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Forslag",
  "selectedAnnouncement": args => "".concat(args.optionText, ", valgt")
};
var $aa4e6d422b8a72e9$exports = {};
$aa4e6d422b8a72e9$exports = {
  "buttonLabel": "Empfehlungen anzeigen",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " Option"),
    other: () => "".concat(formatter.number(args.optionCount), " Optionen")
  }), " verf\xFCgbar."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Eingetretene Gruppe ".concat(args.groupTitle, ", mit ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " Option"),
      other: () => "".concat(formatter.number(args.groupCount), " Optionen")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", ausgew\xE4hlt",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Empfehlungen",
  "selectedAnnouncement": args => "".concat(args.optionText, ", ausgew\xE4hlt")
};
var $b88e038b0dd4dc0a$exports = {};
$b88e038b0dd4dc0a$exports = {
  "buttonLabel": "\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u03C0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03C9\u03BD",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE"),
    other: () => "".concat(formatter.number(args.optionCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2 ")
  }), " \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B5\u03C2."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "\u0395\u03B9\u03C3\u03B1\u03B3\u03BC\u03AD\u03BD\u03B7 \u03BF\u03BC\u03AC\u03B4\u03B1 ".concat(args.groupTitle, ", \u03BC\u03B5 ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE"),
      other: () => "".concat(formatter.number(args.groupCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "\u03A0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2",
  "selectedAnnouncement": args => "".concat(args.optionText, ", \u03B5\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B5")
};
var $dbcec05b5ddcd323$exports = {};
$dbcec05b5ddcd323$exports = {
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Entered group ".concat(args.groupTitle, ", with ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " option"),
      other: () => "".concat(formatter.number(args.groupCount), " options")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", selected",
    other: ""
  }, args.isSelected)),
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " option"),
    other: () => "".concat(formatter.number(args.optionCount), " options")
  }), " available."),
  "selectedAnnouncement": args => "".concat(args.optionText, ", selected"),
  "buttonLabel": "Show suggestions",
  "listboxLabel": "Suggestions"
};
var $3a762c75d410ecfe$exports = {};
$3a762c75d410ecfe$exports = {
  "buttonLabel": "Mostrar sugerencias",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " opci\xF3n"),
    other: () => "".concat(formatter.number(args.optionCount), " opciones")
  }), " disponible(s)."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Se ha unido al grupo ".concat(args.groupTitle, ", con ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " opci\xF3n"),
      other: () => "".concat(formatter.number(args.groupCount), " opciones")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", seleccionado",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Sugerencias",
  "selectedAnnouncement": args => "".concat(args.optionText, ", seleccionado")
};
var $345540ad7e1ca6bf$exports = {};
$345540ad7e1ca6bf$exports = {
  "buttonLabel": "Kuva soovitused",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " valik"),
    other: () => "".concat(formatter.number(args.optionCount), " valikud")
  }), " saadaval."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Sisestatud r\xFChm ".concat(args.groupTitle, ", valikuga ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " valik"),
      other: () => "".concat(formatter.number(args.groupCount), " valikud")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", valitud",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Soovitused",
  "selectedAnnouncement": args => "".concat(args.optionText, ", valitud")
};
var $f314257d456879ad$exports = {};
$f314257d456879ad$exports = {
  "buttonLabel": "N\xE4yt\xE4 ehdotukset",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " vaihtoehto"),
    other: () => "".concat(formatter.number(args.optionCount), " vaihtoehdot")
  }), " saatavilla."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Mentiin ryhm\xE4\xE4n ".concat(args.groupTitle, ", ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " vaihtoehdon"),
      other: () => "".concat(formatter.number(args.groupCount), " vaihtoehdon")
    }), " kanssa."),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", valittu",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Ehdotukset",
  "selectedAnnouncement": args => "".concat(args.optionText, ", valittu")
};
var $ebebc2f5e8da1157$exports = {};
$ebebc2f5e8da1157$exports = {
  "buttonLabel": "Afficher les suggestions",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " option"),
    other: () => "".concat(formatter.number(args.optionCount), " options")
  }), " disponible(s)."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Groupe ".concat(args.groupTitle, " saisi, avec ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " option"),
      other: () => "".concat(formatter.number(args.groupCount), " options")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", s\xE9lectionn\xE9(s)",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Suggestions",
  "selectedAnnouncement": args => "".concat(args.optionText, ", s\xE9lectionn\xE9")
};
var $3dda6220a904406b$exports = {};
$3dda6220a904406b$exports = {
  "buttonLabel": "\u05D4\u05E6\u05D2 \u05D4\u05E6\u05E2\u05D5\u05EA",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "\u05D0\u05E4\u05E9\u05E8\u05D5\u05EA ".concat(formatter.number(args.optionCount)),
    other: () => "".concat(formatter.number(args.optionCount), " \u05D0\u05E4\u05E9\u05E8\u05D5\u05D9\u05D5\u05EA")
  }), " \u05D1\u05DE\u05E6\u05D1 \u05D6\u05DE\u05D9\u05DF."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "\u05E0\u05DB\u05E0\u05E1 \u05DC\u05E7\u05D1\u05D5\u05E6\u05D4 ".concat(args.groupTitle, ", \u05E2\u05DD ").concat(formatter.plural(args.groupCount, {
      one: () => "\u05D0\u05E4\u05E9\u05E8\u05D5\u05EA ".concat(formatter.number(args.groupCount)),
      other: () => "".concat(formatter.number(args.groupCount), " \u05D0\u05E4\u05E9\u05E8\u05D5\u05D9\u05D5\u05EA")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", \u05E0\u05D1\u05D7\u05E8",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "\u05D4\u05E6\u05E2\u05D5\u05EA",
  "selectedAnnouncement": args => "".concat(args.optionText, ", \u05E0\u05D1\u05D7\u05E8")
};
var $21178dd033a9f6f2$exports = {};
$21178dd033a9f6f2$exports = {
  "buttonLabel": "Prika\u017Ei prijedloge",
  "countAnnouncement": (args, formatter) => "Dostupno jo\u0161: ".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " opcija"),
    other: () => "".concat(formatter.number(args.optionCount), " opcije/a")
  }), "."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Unesena skupina ".concat(args.groupTitle, ", s ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " opcijom"),
      other: () => "".concat(formatter.number(args.groupCount), " opcije/a")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", odabranih",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Prijedlozi",
  "selectedAnnouncement": args => "".concat(args.optionText, ", odabrano")
};
var $f12e9cac54fcde83$exports = {};
$f12e9cac54fcde83$exports = {
  "buttonLabel": "Javaslatok megjelen\xEDt\xE9se",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " lehet\u0151s\xE9g"),
    other: () => "".concat(formatter.number(args.optionCount), " lehet\u0151s\xE9g")
  }), " \xE1ll rendelkez\xE9sre."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Bel\xE9pett a(z) ".concat(args.groupTitle, " csoportba, amely ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " lehet\u0151s\xE9get"),
      other: () => "".concat(formatter.number(args.groupCount), " lehet\u0151s\xE9get")
    }), " tartalmaz. "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", kijel\xF6lve",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Javaslatok",
  "selectedAnnouncement": args => "".concat(args.optionText, ", kijel\xF6lve")
};
var $c7ad5d19d847ae9c$exports = {};
$c7ad5d19d847ae9c$exports = {
  "buttonLabel": "Mostra suggerimenti",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " opzione disponibile"),
    other: () => "".concat(formatter.number(args.optionCount), " opzioni disponibili")
  }), "."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Ingresso nel gruppo ".concat(args.groupTitle, ", con ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " opzione"),
      other: () => "".concat(formatter.number(args.groupCount), " opzioni")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", selezionato",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Suggerimenti",
  "selectedAnnouncement": args => "".concat(args.optionText, ", selezionato")
};
var $2cd660cb05523578$exports = {};
$2cd660cb05523578$exports = {
  "buttonLabel": "\u5019\u88DC\u3092\u8868\u793A",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3"),
    other: () => "".concat(formatter.number(args.optionCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3")
  }), "\u3092\u5229\u7528\u3067\u304D\u307E\u3059\u3002"),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "\u5165\u529B\u3055\u308C\u305F\u30B0\u30EB\u30FC\u30D7 ".concat(args.groupTitle, "\u3001").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3"),
      other: () => "".concat(formatter.number(args.groupCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3")
    }), "\u3092\u542B\u3080\u3002"),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: "\u3001\u9078\u629E\u6E08\u307F",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "\u5019\u88DC",
  "selectedAnnouncement": args => "".concat(args.optionText, "\u3001\u9078\u629E\u6E08\u307F")
};
var $854156a4c27f569c$exports = {};
$854156a4c27f569c$exports = {
  "buttonLabel": "\uC81C\uC548 \uC0AC\uD56D \uD45C\uC2DC",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), "\uAC1C \uC635\uC158"),
    other: () => "".concat(formatter.number(args.optionCount), "\uAC1C \uC635\uC158")
  }), "\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "\uC785\uB825\uD55C \uADF8\uB8F9 ".concat(args.groupTitle, ", ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), "\uAC1C \uC635\uC158"),
      other: () => "".concat(formatter.number(args.groupCount), "\uAC1C \uC635\uC158")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", \uC120\uD0DD\uB428",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "\uC81C\uC548",
  "selectedAnnouncement": args => "".concat(args.optionText, ", \uC120\uD0DD\uB428")
};
var $dabe6c727809b774$exports = {};
$dabe6c727809b774$exports = {
  "buttonLabel": "Rodyti pasi\u016Blymus",
  "countAnnouncement": (args, formatter) => "Yra ".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " parinktis"),
    other: () => "".concat(formatter.number(args.optionCount), " parinktys (-i\u0173)")
  }), "."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "\u012Evesta grup\u0117 ".concat(args.groupTitle, ", su ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " parinktimi"),
      other: () => "".concat(formatter.number(args.groupCount), " parinktimis (-i\u0173)")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", pasirinkta",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Pasi\u016Blymai",
  "selectedAnnouncement": args => "".concat(args.optionText, ", pasirinkta")
};
var $7810eacb77cdba0d$exports = {};
$7810eacb77cdba0d$exports = {
  "buttonLabel": "R\u0101d\u012Bt ieteikumus",
  "countAnnouncement": (args, formatter) => "Pieejamo opciju skaits: ".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " opcija"),
    other: () => "".concat(formatter.number(args.optionCount), " opcijas")
  }), "."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Ievad\u012Bta grupa ".concat(args.groupTitle, ", ar ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " opciju"),
      other: () => "".concat(formatter.number(args.groupCount), " opcij\u0101m")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", atlas\u012Bta",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Ieteikumi",
  "selectedAnnouncement": args => "".concat(args.optionText, ", atlas\u012Bta")
};
var $5e329fda39bb6d70$exports = {};
$5e329fda39bb6d70$exports = {
  "buttonLabel": "Vis forslag",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " alternativ"),
    other: () => "".concat(formatter.number(args.optionCount), " alternativer")
  }), " finnes."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Angitt gruppe ".concat(args.groupTitle, ", med ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " alternativ"),
      other: () => "".concat(formatter.number(args.groupCount), " alternativer")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", valgt",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Forslag",
  "selectedAnnouncement": args => "".concat(args.optionText, ", valgt")
};
var $29be2a564837167c$exports = {};
$29be2a564837167c$exports = {
  "buttonLabel": "Suggesties weergeven",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " optie"),
    other: () => "".concat(formatter.number(args.optionCount), " opties")
  }), " beschikbaar."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Groep ".concat(args.groupTitle, " ingevoerd met ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " optie"),
      other: () => "".concat(formatter.number(args.groupCount), " opties")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", geselecteerd",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Suggesties",
  "selectedAnnouncement": args => "".concat(args.optionText, ", geselecteerd")
};
var $7c0ffa214495a56b$exports = {};
$7c0ffa214495a56b$exports = {
  "buttonLabel": "Wy\u015Bwietlaj sugestie",
  "countAnnouncement": (args, formatter) => "dost\u0119pna/dost\u0119pne(-nych) ".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " opcja"),
    other: () => "".concat(formatter.number(args.optionCount), " opcje(-i)")
  }), "."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Do\u0142\u0105czono do grupy ".concat(args.groupTitle, ", z ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " opcj\u0105"),
      other: () => "".concat(formatter.number(args.groupCount), " opcjami")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", wybrano",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Sugestie",
  "selectedAnnouncement": args => "".concat(args.optionText, ", wybrano")
};
var $e8665834548c9563$exports = {};
$e8665834548c9563$exports = {
  "buttonLabel": "Mostrar sugest\xF5es",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " op\xE7\xE3o"),
    other: () => "".concat(formatter.number(args.optionCount), " op\xE7\xF5es")
  }), " dispon\xEDvel."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Grupo inserido ".concat(args.groupTitle, ", com ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " op\xE7\xE3o"),
      other: () => "".concat(formatter.number(args.groupCount), " op\xE7\xF5es")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", selecionado",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Sugest\xF5es",
  "selectedAnnouncement": args => "".concat(args.optionText, ", selecionado")
};
var $3f614fe48e86ff5a$exports = {};
$3f614fe48e86ff5a$exports = {
  "buttonLabel": "Apresentar sugest\xF5es",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " op\xE7\xE3o"),
    other: () => "".concat(formatter.number(args.optionCount), " op\xE7\xF5es")
  }), " dispon\xEDvel."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Grupo introduzido ".concat(args.groupTitle, ", com ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " op\xE7\xE3o"),
      other: () => "".concat(formatter.number(args.groupCount), " op\xE7\xF5es")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", selecionado",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Sugest\xF5es",
  "selectedAnnouncement": args => "".concat(args.optionText, ", selecionado")
};
var $e7efe9ced5993d70$exports = {};
$e7efe9ced5993d70$exports = {
  "buttonLabel": "Afi\u0219are sugestii",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " op\u021Biune"),
    other: () => "".concat(formatter.number(args.optionCount), " op\u021Biuni")
  }), " disponibile."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Grup ".concat(args.groupTitle, " introdus, cu ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " op\u021Biune"),
      other: () => "".concat(formatter.number(args.groupCount), " op\u021Biuni")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", selectat",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Sugestii",
  "selectedAnnouncement": args => "".concat(args.optionText, ", selectat")
};
var $d56743931b3be207$exports = {};
$d56743931b3be207$exports = {
  "buttonLabel": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440"),
    other: () => "".concat(formatter.number(args.optionCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u0432")
  }), " \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "\u0412\u0432\u0435\u0434\u0435\u043D\u043D\u0430\u044F \u0433\u0440\u0443\u043F\u043F\u0430 ".concat(args.groupTitle, ", \u0441 ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u043C"),
      other: () => "".concat(formatter.number(args.groupCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043C\u0438")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u043C\u0438",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "selectedAnnouncement": args => "".concat(args.optionText, ", \u0432\u044B\u0431\u0440\u0430\u043D\u043E")
};
var $68a40ce74b5b67bf$exports = {};
$68a40ce74b5b67bf$exports = {
  "buttonLabel": "Zobrazi\u0165 n\xE1vrhy",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " mo\u017Enos\u0165"),
    other: () => "".concat(formatter.number(args.optionCount), " mo\u017Enosti/-\xED")
  }), " k dispoz\xEDcii."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Zadan\xE1 skupina ".concat(args.groupTitle, ", s ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " mo\u017Enos\u0165ou"),
      other: () => "".concat(formatter.number(args.groupCount), " mo\u017Enos\u0165ami")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", vybrat\xE9",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "N\xE1vrhy",
  "selectedAnnouncement": args => "".concat(args.optionText, ", vybrat\xE9")
};
var $58f7d43d88008c7d$exports = {};
$58f7d43d88008c7d$exports = {
  "buttonLabel": "Prika\u017Ei predloge",
  "countAnnouncement": (args, formatter) => "Na voljo je ".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " opcija"),
    other: () => "".concat(formatter.number(args.optionCount), " opcije")
  }), "."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Vnesena skupina ".concat(args.groupTitle, ", z ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " opcija"),
      other: () => "".concat(formatter.number(args.groupCount), " opcije")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", izbrano",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Predlogi",
  "selectedAnnouncement": args => "".concat(args.optionText, ", izbrano")
};
var $914aa7442fad912d$exports = {};
$914aa7442fad912d$exports = {
  "buttonLabel": "Prika\u017Ei predloge",
  "countAnnouncement": (args, formatter) => "Dostupno jo\u0161: ".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " opcija"),
    other: () => "".concat(formatter.number(args.optionCount), " opcije/a")
  }), "."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Unesena grupa ".concat(args.groupTitle, ", s ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " opcijom"),
      other: () => "".concat(formatter.number(args.groupCount), " optione/a")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", izabranih",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "Predlozi",
  "selectedAnnouncement": args => "".concat(args.optionText, ", izabrano")
};
var $85af38f91b727899$exports = {};
$85af38f91b727899$exports = {
  "buttonLabel": "Visa f\xF6rslag",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " alternativ"),
    other: () => "".concat(formatter.number(args.optionCount), " alternativ")
  }), " tillg\xE4ngliga."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Ingick i gruppen ".concat(args.groupTitle, " med ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " alternativ"),
      other: () => "".concat(formatter.number(args.groupCount), " alternativ")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", valda",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "F\xF6rslag",
  "selectedAnnouncement": args => "".concat(args.optionText, ", valda")
};
var $72a40ca4dde96679$exports = {};
$72a40ca4dde96679$exports = {
  "buttonLabel": "\xD6nerileri g\xF6ster",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " se\xE7enek"),
    other: () => "".concat(formatter.number(args.optionCount), " se\xE7enekler")
  }), " kullan\u0131labilir."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "Girilen grup ".concat(args.groupTitle, ", ile ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " se\xE7enek"),
      other: () => "".concat(formatter.number(args.groupCount), " se\xE7enekler")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", se\xE7ildi",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "\xD6neriler",
  "selectedAnnouncement": args => "".concat(args.optionText, ", se\xE7ildi")
};
var $300dce19c9e0d13f$exports = {};
$300dce19c9e0d13f$exports = {
  "buttonLabel": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440"),
    other: () => "".concat(formatter.number(args.optionCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438(-\u0456\u0432)")
  }), " \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E."),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "\u0412\u0432\u0435\u0434\u0435\u043D\u0430 \u0433\u0440\u0443\u043F\u0430 ".concat(args.groupTitle, ", \u0437 ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440"),
      other: () => "".concat(formatter.number(args.groupCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438(-\u0456\u0432)")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", \u0432\u0438\u0431\u0440\u0430\u043D\u043E",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
  "selectedAnnouncement": args => "".concat(args.optionText, ", \u0432\u0438\u0431\u0440\u0430\u043D\u043E")
};
var $015ff4188b7f78eb$exports = {};
$015ff4188b7f78eb$exports = {
  "buttonLabel": "\u663E\u793A\u5EFA\u8BAE",
  "countAnnouncement": (args, formatter) => "\u6709 ".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " \u4E2A\u9009\u9879"),
    other: () => "".concat(formatter.number(args.optionCount), " \u4E2A\u9009\u9879")
  }), "\u53EF\u7528\u3002"),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "\u8FDB\u5165\u4E86 ".concat(args.groupTitle, " \u7EC4\uFF0C\u5176\u4E2D\u6709 ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " \u4E2A\u9009\u9879"),
      other: () => "".concat(formatter.number(args.groupCount), " \u4E2A\u9009\u9879")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", \u5DF2\u9009\u62E9",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "\u5EFA\u8BAE",
  "selectedAnnouncement": args => "".concat(args.optionText, ", \u5DF2\u9009\u62E9")
};
var $713552ac3e0ac749$exports = {};
$713552ac3e0ac749$exports = {
  "buttonLabel": "\u986F\u793A\u5EFA\u8B70",
  "countAnnouncement": (args, formatter) => "".concat(formatter.plural(args.optionCount, {
    one: () => "".concat(formatter.number(args.optionCount), " \u9078\u9805"),
    other: () => "".concat(formatter.number(args.optionCount), " \u9078\u9805")
  }), " \u53EF\u7528\u3002"),
  "focusAnnouncement": (args, formatter) => "".concat(formatter.select({
    true: () => "\u8F38\u5165\u7684\u7FA4\u7D44 ".concat(args.groupTitle, ", \u6709 ").concat(formatter.plural(args.groupCount, {
      one: () => "".concat(formatter.number(args.groupCount), " \u9078\u9805"),
      other: () => "".concat(formatter.number(args.groupCount), " \u9078\u9805")
    }), ". "),
    other: ""
  }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
    true: ", \u5DF2\u9078\u53D6",
    other: ""
  }, args.isSelected)),
  "listboxLabel": "\u5EFA\u8B70",
  "selectedAnnouncement": args => "".concat(args.optionText, ", \u5DF2\u9078\u53D6")
};
$8d1e5da058b86bb9$exports = {
  "ar-AE": $a756282ae45b5180$exports,
  "bg-BG": $50569559b1387c57$exports,
  "cs-CZ": $bff243ee21f5616f$exports,
  "da-DK": $1508d10b8eb2180a$exports,
  "de-DE": $aa4e6d422b8a72e9$exports,
  "el-GR": $b88e038b0dd4dc0a$exports,
  "en-US": $dbcec05b5ddcd323$exports,
  "es-ES": $3a762c75d410ecfe$exports,
  "et-EE": $345540ad7e1ca6bf$exports,
  "fi-FI": $f314257d456879ad$exports,
  "fr-FR": $ebebc2f5e8da1157$exports,
  "he-IL": $3dda6220a904406b$exports,
  "hr-HR": $21178dd033a9f6f2$exports,
  "hu-HU": $f12e9cac54fcde83$exports,
  "it-IT": $c7ad5d19d847ae9c$exports,
  "ja-JP": $2cd660cb05523578$exports,
  "ko-KR": $854156a4c27f569c$exports,
  "lt-LT": $dabe6c727809b774$exports,
  "lv-LV": $7810eacb77cdba0d$exports,
  "nb-NO": $5e329fda39bb6d70$exports,
  "nl-NL": $29be2a564837167c$exports,
  "pl-PL": $7c0ffa214495a56b$exports,
  "pt-BR": $e8665834548c9563$exports,
  "pt-PT": $3f614fe48e86ff5a$exports,
  "ro-RO": $e7efe9ced5993d70$exports,
  "ru-RU": $d56743931b3be207$exports,
  "sk-SK": $68a40ce74b5b67bf$exports,
  "sl-SI": $58f7d43d88008c7d$exports,
  "sr-SP": $914aa7442fad912d$exports,
  "sv-SE": $85af38f91b727899$exports,
  "tr-TR": $72a40ca4dde96679$exports,
  "uk-UA": $300dce19c9e0d13f$exports,
  "zh-CN": $015ff4188b7f78eb$exports,
  "zh-TW": $713552ac3e0ac749$exports
};
function $242452271d1e4c0e$export$8c18d1b4f7232bbf(props, state) {
  let {
    buttonRef: buttonRef,
    popoverRef: popoverRef,
    inputRef: inputRef,
    listBoxRef: listBoxRef,
    keyboardDelegate: keyboardDelegate,
    shouldFocusWrap:
    // completionMode = 'suggest',
    shouldFocusWrap,
    isReadOnly: isReadOnly,
    isDisabled: isDisabled
  } = props;
  let stringFormatter = (0, $8Zqhq$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($8d1e5da058b86bb9$exports)));
  let {
    menuTriggerProps: menuTriggerProps,
    menuProps: menuProps
  } = (0, $8Zqhq$reactariamenu.useMenuTrigger)({
    type: "listbox",
    isDisabled: isDisabled || isReadOnly
  }, state, buttonRef);
  // Set listbox id so it can be used when calling getItemId later
  (0, $8Zqhq$reactarialistbox.listData).set(state, {
    id: menuProps.id
  });
  // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
  // When virtualized, the layout object will be passed in as a prop and override this.
  let delegate = (0, $8Zqhq$react.useMemo)(() => keyboardDelegate || new (0, $8Zqhq$reactariaselection.ListKeyboardDelegate)(state.collection, state.disabledKeys, listBoxRef), [keyboardDelegate, state.collection, state.disabledKeys, listBoxRef]);
  // Use useSelectableCollection to get the keyboard handlers to apply to the textfield
  let {
    collectionProps: collectionProps
  } = (0, $8Zqhq$reactariaselection.useSelectableCollection)({
    selectionManager: state.selectionManager,
    keyboardDelegate: delegate,
    disallowTypeAhead: true,
    disallowEmptySelection: true,
    shouldFocusWrap: shouldFocusWrap,
    ref: inputRef,
    // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
    isVirtualized: true
  });
  // For textfield specific keydown operations
  let onKeyDown = e => {
    switch (e.key) {
      case "Enter":
      case "Tab":
        // Prevent form submission if menu is open since we may be selecting a option
        if (state.isOpen && e.key === "Enter") e.preventDefault();
        state.commit();
        break;
      case "Escape":
        if (state.selectedKey !== null || state.inputValue === "" || props.allowsCustomValue) e.continuePropagation();
        state.revert();
        break;
      case "ArrowDown":
        state.open("first", "manual");
        break;
      case "ArrowUp":
        state.open("last", "manual");
        break;
      case "ArrowLeft":
      case "ArrowRight":
        state.selectionManager.setFocusedKey(null);
        break;
    }
  };
  let onBlur = e => {
    var _popoverRef_current;
    // Ignore blur if focused moved to the button or into the popover.
    if (e.relatedTarget === (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) || ((_popoverRef_current = popoverRef.current) === null || _popoverRef_current === void 0 ? void 0 : _popoverRef_current.contains(e.relatedTarget))) return;
    if (props.onBlur) props.onBlur(e);
    state.setFocused(false);
  };
  let onFocus = e => {
    if (state.isFocused) return;
    if (props.onFocus) props.onFocus(e);
    state.setFocused(true);
  };
  let {
    labelProps: labelProps,
    inputProps: inputProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  } = (0, $8Zqhq$reactariatextfield.useTextField)({
    ...props,
    onChange: state.setInputValue,
    onKeyDown: !isReadOnly && (0, $8Zqhq$reactariautils.chain)(state.isOpen && collectionProps.onKeyDown, onKeyDown, props.onKeyDown),
    onBlur: onBlur,
    value: state.inputValue,
    onFocus: onFocus,
    autoComplete: "off"
  }, inputRef);
  // Press handlers for the ComboBox button
  let onPress = e => {
    if (e.pointerType === "touch") {
      // Focus the input field in case it isn't focused yet
      inputRef.current.focus();
      state.toggle(null, "manual");
    }
  };
  let onPressStart = e => {
    if (e.pointerType !== "touch") {
      inputRef.current.focus();
      state.toggle(e.pointerType === "keyboard" || e.pointerType === "virtual" ? "first" : null, "manual");
    }
  };
  let triggerLabelProps = (0, $8Zqhq$reactariautils.useLabels)({
    id: menuTriggerProps.id,
    "aria-label": stringFormatter.format("buttonLabel"),
    "aria-labelledby": props["aria-labelledby"] || labelProps.id
  });
  let listBoxProps = (0, $8Zqhq$reactariautils.useLabels)({
    id: menuProps.id,
    "aria-label": stringFormatter.format("listboxLabel"),
    "aria-labelledby": props["aria-labelledby"] || labelProps.id
  });
  // If a touch happens on direct center of ComboBox input, might be virtual click from iPad so open ComboBox menu
  let lastEventTime = (0, $8Zqhq$react.useRef)(0);
  let onTouchEnd = e => {
    if (isDisabled || isReadOnly) return;
    // Sometimes VoiceOver on iOS fires two touchend events in quick succession. Ignore the second one.
    if (e.timeStamp - lastEventTime.current < 500) {
      e.preventDefault();
      inputRef.current.focus();
      return;
    }
    let rect = e.target.getBoundingClientRect();
    let touch = e.changedTouches[0];
    let centerX = Math.ceil(rect.left + .5 * rect.width);
    let centerY = Math.ceil(rect.top + .5 * rect.height);
    if (touch.clientX === centerX && touch.clientY === centerY) {
      e.preventDefault();
      inputRef.current.focus();
      state.toggle(null, "manual");
      lastEventTime.current = e.timeStamp;
    }
  };
  // VoiceOver has issues with announcing aria-activedescendant properly on change
  // (especially on iOS). We use a live region announcer to announce focus changes
  // manually. In addition, section titles are announced when navigating into a new section.
  let focusedItem = state.selectionManager.focusedKey != null && state.isOpen ? state.collection.getItem(state.selectionManager.focusedKey) : undefined;
  var _focusedItem_parentKey;
  let sectionKey = (_focusedItem_parentKey = focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.parentKey) !== null && _focusedItem_parentKey !== void 0 ? _focusedItem_parentKey : null;
  var _state_selectionManager_focusedKey;
  let itemKey = (_state_selectionManager_focusedKey = state.selectionManager.focusedKey) !== null && _state_selectionManager_focusedKey !== void 0 ? _state_selectionManager_focusedKey : null;
  let lastSection = (0, $8Zqhq$react.useRef)(sectionKey);
  let lastItem = (0, $8Zqhq$react.useRef)(itemKey);
  (0, $8Zqhq$react.useEffect)(() => {
    if ((0, $8Zqhq$reactariautils.isAppleDevice)() && focusedItem != null && itemKey !== lastItem.current) {
      let isSelected = state.selectionManager.isSelected(itemKey);
      let section = sectionKey != null ? state.collection.getItem(sectionKey) : null;
      let sectionTitle = (section === null || section === void 0 ? void 0 : section["aria-label"]) || (typeof (section === null || section === void 0 ? void 0 : section.rendered) === "string" ? section.rendered : "") || "";
      let announcement = stringFormatter.format("focusAnnouncement", {
        isGroupChange: section && sectionKey !== lastSection.current,
        groupTitle: sectionTitle,
        groupCount: section ? [...(0, $8Zqhq$reactstatelycollections.getChildNodes)(section, state.collection)].length : 0,
        optionText: focusedItem["aria-label"] || focusedItem.textValue || "",
        isSelected: isSelected
      });
      (0, $8Zqhq$reactarialiveannouncer.announce)(announcement);
    }
    lastSection.current = sectionKey;
    lastItem.current = itemKey;
  });
  // Announce the number of available suggestions when it changes
  let optionCount = (0, $8Zqhq$reactstatelycollections.getItemCount)(state.collection);
  let lastSize = (0, $8Zqhq$react.useRef)(optionCount);
  let lastOpen = (0, $8Zqhq$react.useRef)(state.isOpen);
  (0, $8Zqhq$react.useEffect)(() => {
    // Only announce the number of options available when the menu opens if there is no
    // focused item, otherwise screen readers will typically read e.g. "1 of 6".
    // The exception is VoiceOver since this isn't included in the message above.
    let didOpenWithoutFocusedItem = state.isOpen !== lastOpen.current && (state.selectionManager.focusedKey == null || (0, $8Zqhq$reactariautils.isAppleDevice)());
    if (state.isOpen && (didOpenWithoutFocusedItem || optionCount !== lastSize.current)) {
      let announcement = stringFormatter.format("countAnnouncement", {
        optionCount: optionCount
      });
      (0, $8Zqhq$reactarialiveannouncer.announce)(announcement);
    }
    lastSize.current = optionCount;
    lastOpen.current = state.isOpen;
  });
  // Announce when a selection occurs for VoiceOver. Other screen readers typically do this automatically.
  let lastSelectedKey = (0, $8Zqhq$react.useRef)(state.selectedKey);
  (0, $8Zqhq$react.useEffect)(() => {
    if ((0, $8Zqhq$reactariautils.isAppleDevice)() && state.isFocused && state.selectedItem && state.selectedKey !== lastSelectedKey.current) {
      let optionText = state.selectedItem["aria-label"] || state.selectedItem.textValue || "";
      let announcement = stringFormatter.format("selectedAnnouncement", {
        optionText: optionText
      });
      (0, $8Zqhq$reactarialiveannouncer.announce)(announcement);
    }
    lastSelectedKey.current = state.selectedKey;
  });
  (0, $8Zqhq$react.useEffect)(() => {
    if (state.isOpen) return (0, $8Zqhq$reactariaoverlays.ariaHideOutside)([inputRef.current, popoverRef.current]);
  }, [state.isOpen, inputRef, popoverRef]);
  return {
    labelProps: labelProps,
    buttonProps: {
      ...menuTriggerProps,
      ...triggerLabelProps,
      excludeFromTabOrder: true,
      onPress: onPress,
      onPressStart: onPressStart,
      isDisabled: isDisabled || isReadOnly
    },
    inputProps: (0, $8Zqhq$reactariautils.mergeProps)(inputProps, {
      role: "combobox",
      "aria-expanded": menuTriggerProps["aria-expanded"],
      "aria-controls": state.isOpen ? menuProps.id : undefined,
      // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
      "aria-autocomplete": "list",
      "aria-activedescendant": focusedItem ? (0, $8Zqhq$reactarialistbox.getItemId)(state, focusedItem.key) : undefined,
      onTouchEnd: onTouchEnd,
      // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
      autoCorrect: "off",
      // This disable's the macOS Safari spell check auto corrections.
      spellCheck: "false"
    }),
    listBoxProps: (0, $8Zqhq$reactariautils.mergeProps)(menuProps, listBoxProps, {
      autoFocus: state.focusStrategy,
      shouldUseVirtualFocus: true,
      shouldSelectOnPressUp: true,
      shouldFocusOnHover: true
    }),
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  };
}